const Api = {
  install(Vue, options) {
    Vue.prototype.$api = {
      checkTransactionStatus(transaction) {
        return axios.post(`/transaction/${transaction}/pending`)
      },
      onePageCheckoutRegister(course, data) {
        return axios.post(`/${course}/onepagecheckoutregister`, data)
      },
      onePageCheckout(course, data) {
        return axios.post(`/${course}/onepagecheckout`, data)
      },
      onePageCheckoutSubscriptionRegister(data) {
        return axios.post(`/subscribe/checkout/register`, data)
      },
      onePageCheckoutSubscription(data) {
        return axios.post(`/subscribe/checkout/process`, data)
      },
      onePageCheckoutSubscriptionStripe(data) {
        return axios.post(`/stripe/subscribe/checkout`, data)
      },
      back() {
        return '/'
      },
      getStudent() {
        return axios.post('/student')
      },
      login(credentials) {
        return axios.post(`/checkout/login`, credentials)
      },
      register(credentials) {
        return axios.post(`/checkout/register`, credentials)
      },
      storeComment(lectureId, comment) {
        return axios.post(`/lecture/${lectureId}/comment`, comment)
      },
      removeComment(commentId) {
        return axios.delete(`/comment/${commentId}/remove`)
      },
      fetchLecture(lectureId) {
        return axios.post(`/lecture/${lectureId}/watch`)
      },
      editNote(lectureId, note) {
        return axios.post(`/lecture/${lectureId}/notes`, { note })
      },
      starLecture(lectureId) {
        return axios.post(`/lecture/${lectureId}/star`)
      },
      completeLecture(lectureId) {
        return axios.post(`/lecture/${lectureId}/complete`)
      },
      checkPromoCode(data) {
        return axios.post('/json/promo-code', data)
      },
    }
  },
}

export default Api